import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaBlock } from '../CtaButton';
import { Accent } from './SectionHeading';
import { MOCKUP_URL } from '../../data/images';
const assurances = ['Instant Digital Access', 'One-Time Payment', 'Ready to Use'];
export function HeroSection() {
  return <section className="bg-brand-paper px-5 pb-16 pt-10 lg:px-8 lg:pb-20 lg:pt-14" data-id="element-91" data-mp="12mhl09mna3dn">
      <div className="mx-auto max-w-4xl text-center" data-id="element-92" data-mp="1zbyqanhptnet">
        <p className="inline-flex items-center rounded-[8px] border border-brand-gold/40 bg-brand-ivory px-4 py-2 font-body text-[10px] font-bold uppercase tracking-[0.18em] text-brand-charcoal/75 sm:text-[11px]" data-id="element-93" data-mp="1zbp0azwo7g94">
          For Hair Instructors & Educators
        </p>

        <h1 className="mt-6 font-display text-[2.6rem] font-bold leading-[1.02] tracking-[-0.015em] text-brand-charcoal sm:text-[3.4rem] lg:text-[4.25rem]" data-id="element-94" data-mp="1lbe5jls8phio">
          Plan Your Hair Classes in <Accent data-id="element-95" data-mp="9wr5bw5d6tff">5 Minutes</Accent> — Not Hours.
        </h1>

        <p className="mx-auto mt-6 max-w-2xl text-[16px] font-semibold leading-relaxed text-brand-charcoal sm:text-[17px]" data-id="element-96" data-mp="9zda5o0veuty">
          Stop rebuilding every lesson from scratch.
        </p>
        <p className="mx-auto mt-3 max-w-2xl text-[15px] leading-relaxed text-brand-charcoal/70 sm:text-[16px]" data-id="element-97" data-mp="3demouv3bfcki">
          A complete visual teaching system for cutting, color, styling and advanced techniques —
          made for professionals who teach hair.
        </p>
      </div>

      <img src={MOCKUP_URL} alt="Hair Instructor Ready — six teaching volumes shown on books, tablet, laptop and phone" width={1536} height={1024} loading="eager" decoding="async" className="mx-auto mt-10 block w-full max-w-[600px] object-contain lg:max-w-[900px]" style={{
      filter: 'drop-shadow(0 34px 40px rgba(120, 96, 56, 0.22))'
    }} data-id="element-98" data-mp="2poac96x4krnl" />

      <p className="mx-auto mt-8 max-w-2xl text-center text-[15px] leading-relaxed text-brand-charcoal/75 sm:text-[16px]" data-id="element-99" data-mp="26rr86w16htxw">
        <strong className="font-semibold text-brand-charcoal" data-id="element-100" data-mp="2brwwc288oyb8">6 professional volumes + 5 powerful bonuses</strong>{' '}
        packed with visual teaching resources, technique breakdowns, student activities, assessments
        and instructor tools — ready whenever you need them.
      </p>

      <CtaBlock label="Get Instant Access" className="mt-9" data-id="element-101" data-mp="8f5wsc4h9rle" />

      <ul className="mt-5 flex flex-wrap justify-center gap-x-5 gap-y-2" role="list" data-id="element-102" data-mp="3jqjpmeanzq1">
        {assurances.map(item => <li key={item} className="flex items-center gap-1.5 font-body text-[12px] text-brand-charcoal/60" data-id="element-103" data-mp="107wtenq2pib6">
            <CheckIcon className="h-3.5 w-3.5 text-brand-cta" strokeWidth={2.25} aria-hidden="true" data-id="element-104" data-mp="w50bz0c9rs8t" />
            {item}
          </li>)}
      </ul>
    </section>;
}